import { render, staticRenderFns } from "./CInfoMixLogo.vue?vue&type=template&id=d796dfee&scoped=true"
import script from "./CInfoMixLogo.vue?vue&type=script&lang=js"
export * from "./CInfoMixLogo.vue?vue&type=script&lang=js"
import style0 from "./CInfoMixLogo.vue?vue&type=style&index=0&id=d796dfee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d796dfee",
  null
  
)

export default component.exports